import Axios from "axios";

const baseURL = process.env.BARRAMUNDI;

export default {
    getDeliveryConfig() {
        return Axios.get(`${baseURL}account/petcare-setting`).then(
            response => response.data.response
        );
    },
    updateSetting(params) {
        return Axios.post(`${baseURL}account/petcare-setting`, params).then(
            response => response.data.response
        );
    },
    getPortalUrl() {
        return Axios.get(`${baseURL}account/petcare-setting-link`).then(
            response => response.data.response
        );
    }
};
